// src/api/drivers.js
import { requestJson } from './http';

// Get all drivers
export function getDrivers() {
  return requestJson('/drivers');
}

// Get a single driver
export function fetchDriver(id) {
  return requestJson(`/drivers/${id}`);
}

// Create a new driver
export function createDriver(driverData) {
  // On validation failure (400), this will throw an Error with .validationErrors
  return requestJson('/drivers', {
    method: 'POST',
    body: driverData,
  });
}

// Update an existing driver
export function updateDriver(id, updates) {
  return requestJson(`/drivers/${id}`, {
    method: 'PUT',
    body: updates,
  });
}

// Delete a driver
export async function deleteDriver(id) {
  await requestJson(`/drivers/${id}`, {
    method: 'DELETE',
    expectJson: false,
  });
}
